import React from 'react';
import styled, { css } from 'styled-components';
import { Typography } from 'components/generic/typography';
import type { ToTransientProps } from 'types/styled';
import { SimpleWrapper, StyledListItem } from './components/ListItem/ListItem';
import type { ListProps } from './shared/types';

const ListElement = styled.ul<ToTransientProps<Pick<ListProps, 'divider'>>>`
    margin: 0;
    padding: 0;
    list-style: none;

    ${({ $divider, theme }) =>
        $divider &&
        css`
            ${StyledListItem} + ${StyledListItem}:before {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                height: 1px;
                background-color: ${theme.ColorBorderTertiary};
            }

            ${StyledListItem}:is(:hover, :active, :focus-within, .selected) {
                &:before, & + ${StyledListItem}:before {
                    display: none;
                }
            }
        `}
`;

export default function List(props: ListProps) {
    const { children, header, headerType = 'primary', divider, ...restProps } = props;

    return (
        <>
            {header && (
                <SimpleWrapper>
                    <Typography.Label size={headerType === 'primary' ? 'L' : 'M'} strong={headerType === 'primary'}>
                        {header}
                    </Typography.Label>
                </SimpleWrapper>
            )}
            <ListElement $divider={divider} {...restProps}>
                {children}
            </ListElement>
        </>
    );
}
